import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { useNavigate } from "react-router-dom";
import { GlobalStyles } from '@mui/material';
import './Login.css';
import LoginHeader from '../LoginHeader';



const SuccessPage = () => {
    const navigate = useNavigate();
    return (
        <div className='auth-page login-page'>
            <GlobalStyles
                styles={{
                    ':root': {
                        '--Form-maxWidth': '800px',
                        '--Transition-duration': '0.4s',
                    },
                }}
            />
            <LoginHeader/>
                    <Box
                        component="main"
                        className='login-card'
                    >
                        <Stack sx={{ gap: 4, mb: 2 }}>
                            <Stack sx={{ gap: 1 }}>
                                <div className='mail-verification-image text-center mt-50'><svg xmlns="http://www.w3.org/2000/svg" width="86" height="92" viewBox="0 0 86 92" fill="none">
                                    <path d="M44.4591 8.64372C44.5206 6.96105 43.205 5.5358 41.5222 5.59358C33.9539 5.85346 26.5686 8.10654 20.1257 12.1493C12.8201 16.7333 7.06402 23.4065 3.60569 31.3012C0.147358 39.1959 -0.853289 47.9472 0.733814 56.4175C2.32092 64.8877 6.42237 72.6853 12.5051 78.7966C18.5877 84.9079 26.3703 89.0502 34.8413 90.6853C43.3122 92.3203 52.0797 91.3724 60.0041 87.9647C67.9285 84.557 74.6433 78.8472 79.2758 71.5774C83.36 65.1681 85.6591 57.8075 85.9649 50.2523C86.0331 48.568 84.6141 47.2426 82.9292 47.2942C81.2442 47.3458 79.9333 48.7557 79.8453 50.4392C79.5143 56.7697 77.5522 62.9268 74.1259 68.3036C70.1511 74.5414 64.3895 79.4406 57.5901 82.3645C50.7907 85.2884 43.2679 86.1017 35.9995 84.6988C28.7312 83.2959 22.0534 79.7416 16.8343 74.4979C11.6151 69.2542 8.09591 62.5636 6.73412 55.2959C5.37233 48.0281 6.23092 40.5192 9.19829 33.7452C12.1657 26.9712 17.1046 21.2455 23.3731 17.3122C28.7786 13.9203 34.9573 11.9967 41.3 11.7045C42.9818 11.6271 44.3975 10.3262 44.4591 8.64372Z" fill="#2356B0" />
                                    <path d="M40.0116 55.0293L76.8682 18.6144C78.1776 17.3207 80.2719 17.2819 81.6283 18.5263C83.0867 19.8643 83.124 22.152 81.7099 23.5367L40.0116 64.3705L21.8367 46.5469C20.6246 45.3582 20.615 43.409 21.8153 42.2085C22.9745 41.0491 24.8423 41.0122 26.0464 42.1248L40.0116 55.0293Z" fill="#2356B0" />
                                </svg></div>
                                <Typography component="h1" sx={{ fontSize: '35px', textAlign: 'center' }}>
                                    Success !
                                </Typography>
                                <Typography level="body-sm" sx={{ fontSize: '16px', textAlign: 'center' }}>
                                    A email has been send to your email@domain.com. Please check for an email from company and click on the included link to reset your password.
                                </Typography>
                            </Stack>

                        </Stack>
                        <Stack spacing={2} mt={2}>
                            <div className='but-one text-center mt-20'>
                                <Button sx={{width:'170px !important'}} type="submit" variant="contained" fullWidth onClick={() => {
                                    navigate("/");
                                }}>
                                    Back to home
                                </Button>
                            </div>
                        </Stack>
                    </Box>
        </div>
    )
}

export default SuccessPage
